"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taxonomyComparator = taxonomyComparator;
const taxonomyRanks_js_1 = require("./taxonomyRanks.js");
/**
 * @description sort taxonomies by superkingdom, kingdom, phylum, class, order, family, genus, species
 * @param {import('./Taxonomy.js').Taxonomy} a
 * @param {import('./Taxonomy.js').Taxonomy} b
 * @returns {number}
 */
function taxonomyComparator(a, b) {
    for (const field of taxonomyRanks_js_1.taxonomyRanks) {
        if (a[field] !== b[field]) {
            return (a[field] || '').localeCompare(b[field] || '');
        }
    }
    return 0;
}
//# sourceMappingURL=taxonomyComparator.js.map